(() => {
  const toggle = document.getElementById('navToggle');
  const nav = document.getElementById('siteNav');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    });

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        nav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Ouvrir le menu');
      });
    });
  }

  /* Sous-menu déroulant (méga-menu) : clic pour ouvrir/fermer sur desktop et mobile. */
  document.querySelectorAll('.nav-item-toggle').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      const item = btn.closest('.nav-item');
      const wasOpen = item.classList.contains('nav-item--open');

      document.querySelectorAll('.nav-item--open').forEach((openItem) => {
        openItem.classList.remove('nav-item--open');
        openItem.querySelector('.nav-item-toggle')?.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('nav-item--open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.nav-item')) {
      document.querySelectorAll('.nav-item--open').forEach((openItem) => {
        openItem.classList.remove('nav-item--open');
        openItem.querySelector('.nav-item-toggle')?.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* Le formulaire newsletter est géré nativement par Shopify (form 'customer').
     Le message de confirmation est rendu côté serveur, voir sections/newsletter.liquid. */

  const qtyInputs = document.querySelectorAll('[data-qty-input]');
  qtyInputs.forEach((input) => {
    input.addEventListener('change', () => {
      if (parseInt(input.value, 10) < 1 || !input.value) input.value = 1;
    });
  });

  const revealEls = document.querySelectorAll('.fade-in-up');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    revealEls.forEach((el) => observer.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }
})();
